import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const getAssets = async (userId) => {
  try {
    const token = sessionStorage.getItem('authToken');
    const response = await fetch(`${api_base_url}/api/${api_key}/get/${userId}/darkweb/darkwebAssets`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
    });
    return response.json();
  } catch (error) {
    console.error('Error fetching darkweb assets:', error);
    throw error;
  }
};

const requestDarkweb = async (userId, path) => {
  const token = sessionStorage.getItem("authToken");
  const response = await fetch(
    `${api_base_url}/api/${api_key}/get/${userId}/darkweb/${path}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(
      payload.message || payload.error || "Unable to load dark-web intelligence"
    );
  }
  return payload;
};

export const getDarkwebIntelligence = (userId) =>
  requestDarkweb(userId, "intelligence");

export const getDarkwebProgress = (userId) =>
  requestDarkweb(userId, "progress");
